module.exports = __webpack_public_path__ + "img/Confirm-black.d204f13e.svg";